<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-dark py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-4"></div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-darker" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <estudante-form />
  </div>
</template>
<script>
import EstudanteForm from "@/components/Forms/EstudanteForm.vue";

export default {
  components: {
    EstudanteForm,
  },
};
</script>
<style></style>
